import { createAutoCorrectedDatePipe } from 'text-mask-addons';

import { generateMaskedInput } from '../mask';
import { format, mask, placeholder, placeholderChar } from './constants';

const dateMask = generateMaskedInput({
  mask,
  pipe: createAutoCorrectedDatePipe(format),
  placeholderChar,
  guide: true,
  keepCharPositions: true,
  placeholder,
});

export * from './tools';
export { dateMask };
